export const CREATE_NEW_DRAFT_CATEGORY = "CREATE_NEW_DRAFT_CATEGORY";
export const EDIT_DRAFT_CATEGORY = "EDIT_DRAFT_CATEGORY";
export const SET_TRANSLATIONS = "SET_TRANSLATIONS";
export const SET_CATEGORIES = "SET_CATEGORIES";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const DELETE_CATEGORY_WITH_DRAFTS = "DELETE_CATEGORY_WITH_DRAFTS";




// WEBPACK FOOTER //
// ./src/_app/drafts/constants/drafts-constants.js